import { jsxs as v, jsx as c } from "react/jsx-runtime";
import { E as d, S as f } from "./icons.types-0722eef5.js";
function p({ title: i, titleId: n, size: l, width: o, height: a, extended: r = !1, ...t }) {
  const h = r ? d : f, s = l ? h[l] : o || h[r ? "s" : "l"], e = l ? h[l] : a || h[r ? "s" : "l"];
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: s,
      height: e,
      "aria-labelledby": n,
      ...t,
      children: [
        i ? /* @__PURE__ */ c("title", { id: n, children: i }) : null,
        /* @__PURE__ */ c("g", { clipPath: "url(#Car_Information_svg__a)", children: /* @__PURE__ */ c(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M21.688 30.144a25.293 25.293 0 0 0-.238 2.735h-5.608c-2.01 0-3.133 1.07-4.198 3.792l-1.578 4.137c-.194.512-.653.843-1.159.843H5.121c-.59 0-1.108.568-1.108 1.279s.519 1.279 1.108 1.279h1.26c1.049 0 1.635 1.31.992 2.213L5.929 48.44a3.202 3.202 0 0 0-.657 1.938v8.604c0 .774.422 1.279.952 1.279h2.522c.533 0 .952-.505.952-1.28v-1.156c0-.756.563-1.37 1.256-1.37h21.29c.694 0 1.256.614 1.256 1.37v1.157c0 .774.42 1.279.952 1.279h2.522c.533 0 .982-.791.982-1.561l2.482.536c0 2.224-1.484 3.764-3.464 3.764h-2.522c-1.916 0-3.37-1.68-3.46-3.806H12.206C12.117 61.32 10.666 63 8.747 63H6.223c-1.98 0-3.464-1.791-3.464-4.018v-8.605c0-1.33.428-2.62 1.202-3.645C2.54 46.196 1.5 44.693 1.5 42.93c0-2.216 1.638-4.018 3.621-4.018h2.945l1.263-3.307c1.427-3.642 3.344-5.461 6.513-5.461h5.846ZM47.049 9.22C60.001 9.22 70.5 19.723 70.5 32.671c0 12.949-10.5 23.451-23.45 23.451-12.956 0-23.452-10.502-23.452-23.45 0-12.949 10.496-23.452 23.451-23.452Zm0 3.35c-11.082 0-20.1 9.016-20.1 20.101 0 11.083 9.018 20.101 20.1 20.101 11.086 0 20.104-9.018 20.104-20.1 0-11.086-9.018-20.101-20.104-20.101Zm1.675 15.076v13.4h3.35v3.347H42.027v-3.346h3.347v-10.05h-3.347v-3.35h6.697ZM15.636 38.53c.63.313.907 1.125.62 1.815l-.336.798h5.977c.291.945.646 1.85 1.042 2.74h-8.975c-.915 0-1.521-1.032-1.143-1.942l1.15-2.735c.288-.687 1.035-.99 1.665-.676ZM47.049 19.27a2.512 2.512 0 1 1-2.513 2.51 2.51 2.51 0 0 1 2.513-2.51Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "Car_Information_svg__a", children: /* @__PURE__ */ c(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as CarInformation
};
